import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantService } from '../services/tenant-service';
// import { TenantService } from './tenant.service';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {

    private readonly EXCLUDED_DOMAINS = [
        'dmflowstorage.dmqifs.xyz'
    ];
    constructor(private tenantService: TenantService) { }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        //  Skip excluded domains (storage / assets)
        // if (this.isExcludedDomain(req.url)) {
        //     return next.handle(req);
        // }

        // //  Skip static assets
        // if (req.url.includes('/assets/')) {
        //     return next.handle(req);
        // }


        //  Get tenant from subdomain
        let tenant = this.tenantService.getTenant();

        tenant = 'dmflow';
        //  If tenant not found, send request as-is
        if (!tenant) {
            tenant = 'dmflow';
            // return next.handle(req);
        }

        // Clone request and attach tenant header
        const tenantReq = req.clone({
            setHeaders: {
                'Subdomain': 'dmflow'   // or 'Subdomain': tenant
            }
        });

        // Forward modified request
        return next.handle(tenantReq);
    }

    private isExcludedDomain(url: string): boolean {
        try {
            const parsedUrl = new URL(url);
            return this.EXCLUDED_DOMAINS.includes(parsedUrl.hostname);
        } catch {
            // relative URLs → not excluded
            return false;
        }
    }
}
